/// \file searchDropdownBar.tsx
///
/// \par Copyright Notice:
/// Copyright (c) 2023 by Oshkosh Corporation.
/// All Rights Reserved.
///
/// \par
/// The information contained herein is confidential and proprietary property
/// of Oshkosh Corporation, and may be privileged.  The dissemination,
/// distribution, use, copying, transfer, or disclosure of such information is
/// strictly prohibited except by express written agreement with Oshkosh
/// Corporation, or with one of its subsidiaries.

import * as React from "react";
import { ComboBox } from "@progress/kendo-react-dropdowns";

//id will have the id of the dropdown
//data will contain all potential options in the dropdown
//onFilterChange will contain the onFilterChange event for if the dropdown changes
//onChange will hold the onChangeEvent for the dropdown bar
//placeholder will hold the text to show if no value is selected
//value will hold the value selected from the user
//optional: disabled : if true, dropdown is un-editable

export const SearchDropdownBar = (props:{
  id:string,
  data:any[],
  placeholder:string,
  value:any,
  onFilterChange:(e:any) =>void,
  onChange:(e:{value:null|string}) =>void,
  disabled?:boolean}) => {
    //value of the option represents the row
    //label of the option represents the asset
    const id = props.id;
    const data = props.data;
    const onFilterChange = props.onFilterChange;
    const onChange = props.onChange;
    const placeholder = props.placeholder;
    const value = props.value;
    let disabled = props.disabled;
    if(!disabled){
      disabled=false;
    }
    return (
      <ComboBox
        id = {id}
        filterable={true}
        onFilterChange={onFilterChange}
        onChange={onChange}
        data={data}
        style={{
          width: "91%",
        }}
        placeholder={placeholder}
        value = {value}
        disabled = {disabled}
        />
    );
};